/* eslint-disable */
import firebase from '@/helpers/firebase/firebase';

const state = {
  profile: {},
  loggedIn: true
};

const getters = {
  profile(context) {
    return context.profile;
  },
  loggedIn(context) {
    return context.loggedIn;
  }
};

const mutations = {
  setProfile(context, profile) {
    context.loggedIn = true;
    context.profile = {
      name: profile.displayName,
      picture: profile.photoURL,
      email: profile.email,
      uid: profile.uid
    };
  },
  setLogin(context, login) {
    context.loggedIn = login;
  },
  stateLogout(context) {
    context.loggedIn = false;
    context.profile = {};
  }
};

const actions = {
  async loginGoogle(context) {
    // if user is already logged in return
    if (context.state.loggedIn) return;

    const provider = new firebase.auth.GoogleAuthProvider();
    try {
      await firebase.auth().signInWithPopup(provider);
      context.commit('setProfile', firebase.auth().currentUser);
    } catch (error) {
      console.log(error);
    }
  },
  async loginEmailPassword(context, data) {
    // if (context.state.loggedIn) return;
    // try {
    //   await firebase
    //     .auth()
    //     .signInWithEmailAndPassword(data.username, data.password)
    //     .catch(function(error) {
    //       let errorCode = error.code;
    //       let errorMessage = error.message;

    //       if (errorCode.length !== 0 || errorMessage !== 0) {
    //         console.log(errorCode);
    //         console.log(errorMessage);
    //       }
    //     });
    //   // await firebase.auth().loginEmailPassword();
    //   context.commit('setProfile', firebase.auth().currentUser);
    //   context.commit('setLogin', true);
    // } catch (error) {
    //   console.log(error);
    // }
    context.commit('setProfile', {});
    context.commit('setLogin', true);
  },
  async loginTwitter(context) {
    if (context.state.loggedIn) return;

    const provider = new firebase.auth.TwitterAuthProvider();
    try {
      await firebase.auth().signInWithPopup(provider);
    } catch (error) {
      console.log(error);
    }
  },

  async logOut(context) {
    try {
      await firebase.auth().signOut();
      context.commit('stateLogout');
    } catch (error) {
      console.log(error);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
